import styled from 'styled-components'

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`
